import { motion } from 'framer-motion';

const container = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.5, staggerChildren: 0.12 } },
};

const row = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

const OurValuesSection = () => {
  const img = `${process.env.PUBLIC_URL || ''}/images/ourvalues.jpg`;

  return (
    <motion.section
      className="bg-white py-10 md:py-14 font-sans"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.35 }}
      variants={container}
    >
      <div className="w-full max-w-7xl mx-auto px-6 md:px-12">
        <motion.h2
          className="text-3xl md:text-5xl font-extrabold text-neutral-900 text-center mb-6 md:mb-8"
          style={{ fontFamily: 'Inter, sans-serif' }}
          variants={row}
        >
          Our Values
        </motion.h2>

<br></br>

        <motion.figure
          className="relative w-full max-w-5xl mx-auto rounded-3xl overflow-hidden shadow-xl"
          variants={row}
          whileHover={{ scale: 1.005 }}
        >
          <div className="relative w-full aspect-[16/9] sm:aspect-[18/9] md:aspect-[20/9]">
            <img
              src={img}
              alt="Lincoln AIM core values"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </div>
        </motion.figure>

      </div>
    </motion.section>
  );
};

export default OurValuesSection;
